import * as React from "react";

const SocialLinks = () => {
  return (
    <React.Fragment>
      <div className="whatsapp-swipe">
        <ul>
          <li className="whatsappline">
            <a
              target="_blank"
              rel="noreferrer"
              href="https://wa.me/+919500139200"
              aria-label="Reach Justty and build your website"
            >
              <i>
                <svg
                  role="img"
                  widths={30}
                  height={30}
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  alt="whatsapp"
                >
                  <path
                    fill="#fff"
                    d="M12.04 2C6.58 2 2.13 6.45 2.13 11.91C2.13 13.66 2.59 15.36 3.45 16.86L2.05 22L7.3 20.62C8.75 21.41 10.38 21.83 12.04 21.83C17.5 21.83 21.95 17.38 21.95 11.92C21.95 9.27 20.92 6.78 19.05 4.91C17.18 3.03 14.69 2 12.04 2M12.05 3.67C14.25 3.67 16.31 4.53 17.87 6.09C19.42 7.65 20.28 9.72 20.28 11.92C20.28 16.46 16.58 20.15 12.04 20.15C10.56 20.15 9.11 19.76 7.85 19L7.55 18.83L4.43 19.65L5.26 16.61L5.06 16.29C4.24 15 3.8 13.47 3.8 11.91C3.81 7.37 7.5 3.67 12.05 3.67M8.53 7.33C8.37 7.33 8.1 7.39 7.87 7.64C7.65 7.89 7 8.5 7 9.71C7 10.93 7.89 12.1 8 12.27C8.14 12.44 9.76 14.94 12.25 16C12.84 16.27 13.3 16.42 13.66 16.53C14.25 16.72 14.79 16.69 15.22 16.63C15.7 16.56 16.68 16.03 16.89 15.45C17.1 14.87 17.1 14.38 17.04 14.27C16.97 14.17 16.81 14.11 16.56 14C16.31 13.86 15.09 13.26 14.87 13.18C14.64 13.1 14.5 13.06 14.31 13.3C14.15 13.55 13.67 14.11 13.53 14.27C13.38 14.44 13.24 14.46 13 14.34C12.74 14.21 11.94 13.95 11 13.11C10.26 12.45 9.77 11.64 9.62 11.39C9.5 11.15 9.61 11 9.73 10.89C9.84 10.78 10 10.6 10.1 10.45C10.23 10.31 10.27 10.2 10.35 10.04C10.43 9.87 10.39 9.73 10.33 9.61C10.27 9.5 9.77 8.26 9.56 7.77C9.36 7.29 9.16 7.35 9 7.34C8.86 7.34 8.7 7.33 8.53 7.33Z"
                  />
                </svg>
              </i>
            </a>
          </li>
          <li className="whatsappline">
            <a
              href="https://t.me/justtrytech"
              target="_blank"
              rel="noreferrer"
              aria-label="Reach Justty and build your website"
            >
              <i>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  role="img"
                  alt="telegram"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M17.5 4.41515C17.7159 4.32429 17.9522 4.29295 18.1843 4.3244C18.4164 4.35585 18.6358 4.44894 18.8197 4.59397C19.0037 4.73901 19.1454 4.93069 19.2301 5.14907C19.3148 5.36744 19.3394 5.60453 19.3014 5.83566L17.32 17.854C17.1278 19.0133 15.8558 19.6781 14.7926 19.1007C13.9033 18.6176 12.5824 17.8732 11.3943 17.0966C10.8002 16.7078 8.98046 15.4629 9.2041 14.5771C9.3963 13.8197 12.454 10.9734 14.2012 9.28121C14.887 8.61638 14.5742 8.23287 13.7644 8.8444C11.7524 10.3627 8.52443 12.6717 7.45687 13.3217C6.51511 13.8948 6.02413 13.9926 5.43706 13.8948C4.36601 13.7166 3.3727 13.4405 2.56198 13.1042C1.46647 12.6499 1.51976 11.1438 2.56111 10.7052L17.5 4.41515Z"
                    fill="white"
                  />
                </svg>
              </i>
            </a>
          </li>
          <li className="whatsappline">
            <a
              target="_blank"
              href="https://www.linkedin.com/company/justtry-technologies/?originalSubdomain=in9"
              rel="noreferrer"
              aria-label="Reach Justty and build your website"
            >
              <i>
                <svg
                  width={30}
                  height={33}
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  role="img"
                  alt="linkedin"
                >
                  <path
                    fill="#fff"
                    d="M19 3A2 2 0 0 1 21 5V19A2 2 0 0 1 19 21H5A2 2 0 0 1 3 19V5A2 2 0 0 1 5 3H19M18.5 18.5V13.2A3.26 3.26 0 0 0 15.24 9.94C14.39 9.94 13.4 10.46 12.92 11.24V10.13H10.13V18.5H12.92V13.57C12.92 12.8 13.54 12.17 14.31 12.17A1.4 1.4 0 0 1 15.71 13.57V18.5H18.5M6.88 8.56A1.68 1.68 0 0 0 8.56 6.88C8.56 5.95 7.81 5.19 6.88 5.19A1.69 1.69 0 0 0 5.19 6.88C5.19 7.81 5.95 8.56 6.88 8.56M8.27 18.5V10.13H5.5V18.5H8.27Z"
                  />
                </svg>
              </i>
            </a>
          </li>
          <li className="whatsappline">
            <a
              href="https://teams.live.com/l/invite/FEA0FXHZ26NDIC8LgE"
              target="_blank"
              rel="noreferrer"
              aria-label="Reach Justty and build your website"
            >
              <i>
                <svg xmlns="http://www.w3.org/2000/svg" width="316" height="316" viewBox="0 0 316 316" fill="none">
                  <rect width="316" height="316" rx="30" fill="white" />
                  <g clipPath="url(#clip0_2_18)">
                    <path d="M197.945 134.144H250.184C255.12 134.144 259.12 138.145 259.12 143.08V190.663C259.12 208.801 244.416 223.506 226.277 223.506H226.122C207.983 223.508 193.277 208.806 193.274 190.667V138.815C193.274 138.201 193.395 137.594 193.629 137.027C193.864 136.46 194.208 135.945 194.642 135.511C195.075 135.078 195.59 134.733 196.157 134.499C196.724 134.264 197.331 134.143 197.945 134.144Z" fill="#5059C9" />
                    <path d="M233.252 124.738C244.941 124.738 254.417 115.262 254.417 103.573C254.417 91.8839 244.941 82.4081 233.252 82.4081C221.563 82.4081 212.087 91.8839 212.087 103.573C212.087 115.262 221.563 124.738 233.252 124.738Z" fill="#5059C9" />
                    <path d="M167.406 124.738C184.291 124.738 197.978 111.051 197.978 94.1664C197.978 77.2823 184.291 63.595 167.406 63.595C150.522 63.595 136.835 77.2823 136.835 94.1664C136.835 111.051 150.522 124.738 167.406 124.738Z" fill="#7B83EB" />
                    <path d="M208.169 134.144H121.94C117.063 134.264 113.206 138.312 113.319 143.188V197.459C112.638 226.724 135.79 251.009 165.054 251.726C194.318 251.009 217.471 226.724 216.791 197.459V143.188C216.904 138.312 213.046 134.264 208.169 134.144Z" fill="#7B83EB" />
                    <path opacity="0.1" d="M169.758 134.144V210.195C169.747 211.901 169.232 213.566 168.278 214.98C167.324 216.394 165.974 217.495 164.397 218.144C163.37 218.579 162.266 218.802 161.151 218.802H117.457C116.846 217.25 116.282 215.698 115.811 214.099C114.164 208.703 113.324 203.092 113.318 197.449V143.174C113.205 138.305 117.057 134.264 121.925 134.144L169.758 134.144Z" fill="black" />
                    <path opacity="0.2" d="M165.055 134.144V214.899C165.055 216.014 164.831 217.117 164.396 218.144C163.747 219.722 162.646 221.072 161.232 222.026C159.818 222.98 158.153 223.495 156.447 223.506H119.669C118.87 221.954 118.117 220.401 117.459 218.802C116.826 217.265 116.277 215.695 115.812 214.099C114.166 208.703 113.326 203.092 113.32 197.449V143.174C113.207 138.305 117.058 134.264 121.927 134.144L165.055 134.144Z" fill="black" />
                    <path opacity="0.2" d="M165.055 134.144V205.492C165.019 210.231 161.187 214.064 156.448 214.099H115.812C114.165 208.703 113.325 203.092 113.319 197.449V143.174C113.206 138.305 117.058 134.264 121.926 134.144L165.055 134.144Z" fill="black" />
                    <path opacity="0.2" d="M160.352 134.144V205.492C160.316 210.231 156.483 214.064 151.745 214.099H115.812C114.165 208.703 113.325 203.092 113.319 197.449V143.174C113.206 138.305 117.058 134.264 121.926 134.144L160.352 134.144Z" fill="black" />
                    <path opacity="0.1" d="M169.758 109.828V124.643C168.959 124.691 168.206 124.738 167.406 124.738C166.607 124.738 165.854 124.691 165.054 124.643C163.467 124.538 161.893 124.286 160.351 123.891C155.656 122.779 151.291 120.571 147.612 117.449C143.934 114.326 141.046 110.377 139.187 105.925C138.537 104.408 138.033 102.833 137.682 101.221H161.151C165.896 101.239 169.74 105.082 169.758 109.828Z" fill="black" />
                    <path opacity="0.2" d="M165.054 114.531V124.643C163.467 124.538 161.893 124.286 160.352 123.891C155.656 122.779 151.291 120.571 147.613 117.449C143.934 114.326 141.047 110.377 139.188 105.925H156.447C161.194 105.942 165.036 109.786 165.054 114.531Z" fill="black" />
                    <path opacity="0.2" d="M165.054 114.531V124.643C163.467 124.538 161.893 124.286 160.352 123.891C155.656 122.779 151.291 120.571 147.613 117.449C143.934 114.326 141.047 110.377 139.188 105.925H156.447C161.194 105.942 165.036 109.786 165.054 114.531Z" fill="black" />
                    <path opacity="0.2" d="M160.352 114.531V123.891C155.657 122.779 151.291 120.571 147.612 117.448C143.934 114.326 141.047 110.377 139.187 105.924H151.745C156.491 105.942 160.334 109.786 160.352 114.531Z" fill="black" />
                    <path d="M65.5012 105.924H151.73C156.492 105.924 160.352 109.784 160.352 114.545V200.775C160.352 205.536 156.492 209.396 151.73 209.396H65.5012C60.7398 209.396 56.8799 205.536 56.8799 200.775V114.546C56.8799 109.783 60.7398 105.924 65.5012 105.924Z" fill="url(#paint0_linear_2_18)" />
                    <path d="M131.305 138.744H114.067V185.682H103.085V138.744H85.9277V129.638H131.305V138.744Z" fill="white" />
                  </g>
                  <defs>
                    <linearGradient id="paint0_linear_2_18" x1="1854.39" y1="-567.683" x2="8606.63" y2="11126.7" gradientUnits="userSpaceOnUse">
                      <stop stop-color="#5A62C3" />
                      <stop offset="0.5" stop-color="#4D55BD" />
                      <stop offset="1" stop-color="#3940AB" />
                    </linearGradient>
                    <clipPath id="clip0_2_18">
                      <rect width="202.24" height="188.81" fill="white" transform="translate(56.8799 63.595)" />
                    </clipPath>
                  </defs>
                </svg>
              </i>
            </a>
          </li>
          <li className="whatsappline">
            <a
              target="_blank"
              rel="noreferrer"
              href="mailto:sales@justtrytech.com"
              aria-label="Reach Justty and build your website"
            >
              <i>
                {" "}
                <svg
                  width={30}
                  height={33}
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  role="img"
                  alt="gmail"
                >
                  <path
                    fill="#fff"
                    d="M20,18H18V9.25L12,13L6,9.25V18H4V6H5.2L12,10.25L18.8,6H20M20,4H4C2.89,4 2,4.89 2,6V18A2,2 0 0,0 4,20H20A2,2 0 0,0 22,18V6C22,4.89 21.1,4 20,4Z"
                  />
                </svg>
              </i>
            </a>
          </li>
        </ul>
      </div>
      <div className="mob_social_links">
        <ul>
          <li>
            <a
              target="_blank"
              rel="noreferrer"
              href="https://wa.me/+919500139200"
              aria-label="Reach Justty and build your website"
            >
              <i>
                <svg
                  width="32"
                  height="33"
                  viewBox="0 0 32 33"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clipPath="url(#clip0_7374_15927)">
                    <path
                      d="M0.683437 16.188C0.682687 18.8976 1.39069 21.5434 2.73694 23.8754L0.554688 31.8431L8.70869 29.7051C10.964 30.9329 13.4909 31.5762 16.0587 31.5764H16.0654C24.5423 31.5764 31.4427 24.6785 31.4463 16.2001C31.4479 12.0917 29.8494 8.2285 26.9452 5.322C24.0414 2.41575 20.1796 0.814375 16.0648 0.8125C7.58694 0.8125 0.687063 7.71 0.683563 16.188"
                      fill="url(#paint0_linear_7374_15927)"
                    />
                    <path
                      d="M0.13375 16.1848C0.132875 18.9919 0.86625 21.7323 2.2605 24.1478L0 32.4012L8.44637 30.1866C10.7736 31.4554 13.3939 32.1244 16.0601 32.1254H16.067C24.848 32.1254 31.9963 24.9794 32 16.1976C32.0015 11.9416 30.3455 7.93944 27.3375 4.92881C24.3291 1.91856 20.3291 0.259563 16.067 0.257812C7.2845 0.257812 0.13725 7.40281 0.13375 16.1848ZM5.16388 23.7318L4.8485 23.2312C3.52275 21.1232 2.823 18.6872 2.824 16.1858C2.82675 8.88644 8.76725 2.94781 16.072 2.94781C19.6095 2.94931 22.934 4.32831 25.4345 6.83031C27.9349 9.33256 29.3108 12.6588 29.3099 16.1966C29.3066 23.4959 23.366 29.4353 16.067 29.4353H16.0618C13.6851 29.4341 11.3542 28.7958 9.3215 27.5897L8.83775 27.3028L3.8255 28.6169L5.16388 23.7318Z"
                      fill="url(#paint1_linear_7374_15927)"
                    />
                    <path
                      d="M12.0845 9.52526C11.7862 8.86239 11.4723 8.84901 11.1887 8.83739C10.9565 8.82739 10.691 8.82814 10.4257 8.82814C10.1602 8.82814 9.72883 8.92801 9.3642 9.32614C8.9992 9.72464 7.9707 10.6876 7.9707 12.6463C7.9707 14.6049 9.39733 16.4979 9.5962 16.7638C9.79533 17.0291 12.3503 21.1771 16.3968 22.7729C19.7598 24.099 20.4442 23.8353 21.1741 23.7688C21.9041 23.7025 23.5296 22.806 23.8612 21.8764C24.1931 20.9469 24.1931 20.1501 24.0936 19.9836C23.9941 19.8178 23.7286 19.7181 23.3305 19.5191C22.9323 19.3201 20.975 18.3569 20.6101 18.224C20.2451 18.0913 19.9797 18.025 19.7142 18.4236C19.4487 18.8216 18.6863 19.7181 18.454 19.9836C18.2218 20.2498 17.9895 20.2829 17.5915 20.0838C17.1931 19.884 15.911 19.4641 14.3898 18.108C13.2063 17.0528 12.4073 15.7496 12.1751 15.351C11.9428 14.953 12.1502 14.7373 12.3498 14.5389C12.5287 14.3605 12.7481 14.074 12.9473 13.8416C13.1458 13.6091 13.2121 13.4433 13.3448 13.1778C13.4777 12.912 13.4112 12.6795 13.3118 12.4804C13.2121 12.2813 12.4385 10.3124 12.0845 9.52526Z"
                      fill="white"
                    />
                  </g>
                  <defs>
                    <linearGradient
                      id="paint0_linear_7374_15927"
                      x1="1545.14"
                      y1="3103.88"
                      x2="1545.14"
                      y2="0.8125"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stopColor="#1FAF38" />
                      <stop offset="1" stopColor="#60D669" />
                    </linearGradient>
                    <linearGradient
                      id="paint1_linear_7374_15927"
                      x1="1600"
                      y1="3214.6"
                      x2="1600"
                      y2="0.257812"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stopColor="#F9F9F9" />
                      <stop offset="1" stopColor="white" />
                    </linearGradient>
                    <clipPath id="clip0_7374_15927">
                      <rect
                        width="32"
                        height="32.25"
                        fill="white"
                        transform="translate(0 0.257812)"
                      />
                    </clipPath>
                  </defs>
                </svg>
              </i>
              Whatsapp
            </a>
          </li>
          <li>
            <a
              href="https://t.me/justtrytech"
              target="_blank"
              rel="noreferrer"
              aria-label="Reach Justty and build your website"
            >
              <i>
                <svg
                  width="32"
                  height="33"
                  viewBox="0 0 32 33"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clipPath="url(#clip0_7374_15934)">
                    <path
                      d="M16 0.382812C11.7575 0.382812 7.685 2.06956 4.6875 5.06906C1.68693 8.06977 0.000858621 12.1393 0 16.3828C0 20.6246 1.6875 24.6971 4.6875 27.6966C7.685 30.6961 11.7575 32.3828 16 32.3828C20.2425 32.3828 24.315 30.6961 27.3125 27.6966C30.3125 24.6971 32 20.6246 32 16.3828C32 12.1411 30.3125 8.06856 27.3125 5.06906C24.315 2.06956 20.2425 0.382812 16 0.382812Z"
                      fill="url(#paint0_linear_7374_15934)"
                    />
                    <path
                      d="M7.24311 16.2148C11.9081 14.1828 15.0181 12.8432 16.5731 12.1958C21.0181 10.3476 21.9406 10.0266 22.5431 10.0157C22.6756 10.0136 22.9706 10.0463 23.1631 10.202C23.3231 10.3332 23.3681 10.5107 23.3906 10.6353C23.4106 10.7598 23.4381 11.0436 23.4156 11.2651C23.1756 13.7951 22.1331 19.9346 21.6031 22.7683C21.3806 23.9673 20.9381 24.3693 20.5106 24.4086C19.5806 24.4941 18.8756 23.7946 17.9756 23.2048C16.5681 22.2816 15.7731 21.7071 14.4056 20.8063C12.8256 19.7653 13.8506 19.1931 14.7506 18.2581C14.9856 18.0133 19.0806 14.2896 19.1581 13.9518C19.1681 13.9096 19.1781 13.7521 19.0831 13.6691C18.9906 13.5858 18.8531 13.6143 18.7531 13.6368C18.6106 13.6688 16.3631 15.1558 12.0031 18.0976C11.3656 18.5361 10.7881 18.7498 10.2681 18.7386C9.69811 18.7263 8.59811 18.4156 7.78061 18.1501C6.78061 17.8243 5.98311 17.6521 6.05311 17.0988C6.08811 16.8108 6.48561 16.5161 7.24311 16.2148Z"
                      fill="white"
                    />
                  </g>
                  <defs>
                    <linearGradient
                      id="paint0_linear_7374_15934"
                      x1="1600"
                      y1="0.382812"
                      x2="1600"
                      y2="3200.38"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stopColor="#2AABEE" />
                      <stop offset="1" stopColor="#229ED9" />
                    </linearGradient>
                    <clipPath id="clip0_7374_15934">
                      <rect
                        width="32"
                        height="32"
                        fill="white"
                        transform="translate(0 0.382812)"
                      />
                    </clipPath>
                  </defs>
                </svg>
              </i>
              Telegram
            </a>
          </li>
          <li>
            <a
              href="https://www.linkedin.com/company/justtry-technologies/?originalSubdomain=in9"
              target="_blank"
              rel="noreferrer"
              aria-label="Reach Justty and build your website"
            >
              <i>
                <svg
                  width="32"
                  height="33"
                  viewBox="0 0 32 33"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clipPath="url(#clip0_7510_13692)">
                    <path
                      d="M24.5 0.0625H7.5C3.35786 0.0625 0 3.42036 0 7.5625V24.5625C0 28.7046 3.35786 32.0625 7.5 32.0625H24.5C28.6421 32.0625 32 28.7046 32 24.5625V7.5625C32 3.42036 28.6421 0.0625 24.5 0.0625Z"
                      fill="white"
                    />
                    <path
                      d="M24.5 0.0625H7.5C3.35786 0.0625 0 3.42036 0 7.5625V24.5625C0 28.7046 3.35786 32.0625 7.5 32.0625H24.5C28.6421 32.0625 32 28.7046 32 24.5625V7.5625C32 3.42036 28.6421 0.0625 24.5 0.0625Z"
                      fill="#0A66C2"
                    />
                    <path
                      d="M23.0894 27.2731H26.7481C26.8807 27.2731 27.0079 27.2205 27.1016 27.1267C27.1954 27.033 27.2481 26.9058 27.2481 26.7733L27.25 19.043C27.25 15.0026 26.3794 11.897 21.6577 11.897C19.8629 11.8303 18.1702 12.7555 17.2569 14.3005C17.2524 14.308 17.2456 14.3138 17.2375 14.3171C17.2294 14.3204 17.2205 14.3209 17.2121 14.3187C17.2036 14.3164 17.1962 14.3114 17.1908 14.3045C17.1855 14.2976 17.1826 14.2891 17.1825 14.2804V12.77C17.1825 12.6374 17.1298 12.5102 17.0361 12.4164C16.9423 12.3227 16.8151 12.27 16.6825 12.27H13.2104C13.0778 12.27 12.9506 12.3227 12.8568 12.4164C12.7631 12.5102 12.7104 12.6374 12.7104 12.77V26.7725C12.7104 26.9051 12.7631 27.0323 12.8568 27.1261C12.9506 27.2198 13.0778 27.2725 13.2104 27.2725H16.8689C17.0015 27.2725 17.1287 27.2198 17.2224 27.1261C17.3162 27.0323 17.3689 26.9051 17.3689 26.7725V19.8509C17.3689 17.8938 17.7401 15.9984 20.1665 15.9984C22.5584 15.9984 22.5894 18.2379 22.5894 19.9776V26.7731C22.5894 26.9057 22.6421 27.0329 22.7358 27.1267C22.8296 27.2204 22.9568 27.2731 23.0894 27.2731ZM4.75 7.516C4.75 8.999 5.97088 10.2192 7.454 10.2192C8.93675 10.2191 10.1569 8.99813 10.1569 7.51538C10.1566 6.03263 8.93637 4.8125 7.4535 4.8125C5.97025 4.8125 4.75 6.033 4.75 7.516ZM5.61987 27.2731H9.28325C9.41586 27.2731 9.54304 27.2204 9.6368 27.1267C9.73057 27.0329 9.78325 26.9057 9.78325 26.7731V12.77C9.78325 12.6374 9.73057 12.5102 9.6368 12.4164C9.54304 12.3227 9.41586 12.27 9.28325 12.27H5.61987C5.48727 12.27 5.36009 12.3227 5.26632 12.4164C5.17255 12.5102 5.11987 12.6374 5.11987 12.77V26.7731C5.11987 26.9057 5.17255 27.0329 5.26632 27.1267C5.36009 27.2204 5.48727 27.2731 5.61987 27.2731Z"
                      fill="white"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_7510_13692">
                      <rect
                        width="32"
                        height="32"
                        fill="white"
                        transform="translate(0 0.0625)"
                      />
                    </clipPath>
                  </defs>
                </svg>
              </i>
              LinkedIn
            </a>
          </li>
          <li>
            <a
              href="https://teams.live.com/l/invite/FEA0FXHZ26NDIC8LgE"
              target="_blank"
              rel="noreferrer"
              aria-label="Reach Justty and build your website"
            >
              <i>
                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="33" viewBox="0 0 256 239"><defs><linearGradient id="logosMicrosoftTeams0" x1="17.372%" x2="82.628%" y1="-6.51%" y2="106.51%"><stop offset="0%" stop-color="#5a62c3" /><stop offset="50%" stop-color="#4d55bd" /><stop offset="100%" stop-color="#3940ab" /></linearGradient><path id="logosMicrosoftTeams1" d="M136.93 64.476v12.8a32.7 32.7 0 0 1-5.953-.952a38.7 38.7 0 0 1-26.79-22.742h21.848c6.008.022 10.872 4.887 10.895 10.894" /></defs><path fill="#5059c9" d="M178.563 89.302h66.125c6.248 0 11.312 5.065 11.312 11.312v60.231c0 22.96-18.613 41.574-41.573 41.574h-.197c-22.96.003-41.576-18.607-41.579-41.568V95.215a5.91 5.91 0 0 1 5.912-5.913" /><circle cx="223.256" cy="50.605" r="26.791" fill="#5059c9" /><circle cx="139.907" cy="38.698" r="38.698" fill="#7b83eb" /><path fill="#7b83eb" d="M191.506 89.302H82.355c-6.173.153-11.056 5.276-10.913 11.449v68.697c-.862 37.044 28.445 67.785 65.488 68.692c37.043-.907 66.35-31.648 65.489-68.692v-68.697c.143-6.173-4.74-11.296-10.913-11.449" /><path d="M142.884 89.302v96.268a10.96 10.96 0 0 1-6.787 10.062c-1.3.55-2.697.833-4.108.833H76.68c-.774-1.965-1.488-3.93-2.084-5.953a72.5 72.5 0 0 1-3.155-21.076v-68.703c-.143-6.163 4.732-11.278 10.895-11.43z" opacity="0.1" /><path d="M136.93 89.302v102.222c0 1.411-.283 2.808-.833 4.108a10.96 10.96 0 0 1-10.062 6.787H79.48c-1.012-1.965-1.965-3.93-2.798-5.954a59 59 0 0 1-2.084-5.953a72.5 72.5 0 0 1-3.155-21.076v-68.703c-.143-6.163 4.732-11.278 10.895-11.43z" opacity="0.2" /><path d="M136.93 89.302v90.315c-.045 5.998-4.896 10.85-10.895 10.895H74.597a72.5 72.5 0 0 1-3.155-21.076v-68.703c-.143-6.163 4.732-11.278 10.895-11.43z" opacity="0.2" /><path d="M130.977 89.302v90.315c-.046 5.998-4.897 10.85-10.895 10.895H74.597a72.5 72.5 0 0 1-3.155-21.076v-68.703c-.143-6.163 4.732-11.278 10.895-11.43z" opacity="0.2" /><path d="M142.884 58.523v18.753c-1.012.06-1.965.12-2.977.12s-1.965-.06-2.977-.12a32.7 32.7 0 0 1-5.953-.952a38.7 38.7 0 0 1-26.791-22.742a33 33 0 0 1-1.905-5.954h29.708c6.007.023 10.872 4.887 10.895 10.895" opacity="0.1" /><use href="#logosMicrosoftTeams1" opacity="0.2" /><use href="#logosMicrosoftTeams1" opacity="0.2" /><path d="M130.977 64.476v11.848a38.7 38.7 0 0 1-26.791-22.743h15.896c6.008.023 10.872 4.888 10.895 10.895" opacity="0.2" /><path fill="url(#logosMicrosoftTeams0)" d="M10.913 53.581h109.15c6.028 0 10.914 4.886 10.914 10.913v109.151c0 6.027-4.886 10.913-10.913 10.913H10.913C4.886 184.558 0 179.672 0 173.645V64.495C0 58.466 4.886 53.58 10.913 53.58" /><path fill="#fff" d="M94.208 95.125h-21.82v59.416H58.487V95.125H36.769V83.599h57.439z" /></svg>
              </i>
              Teams
            </a>
          </li>
          <li>
            <a
              href="mailto:sales@justtrytech.com"
              target="_blank"
              rel="noreferrer"
              aria-label="Reach Justty and build your website"
            >
              <i>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="32"
                  height="30"
                  viewBox="0 0 32 25"
                  fill="none"
                >
                  <g clipPath="url(#clip0_7509_13680)">
                    <path
                      d="M7.27275 24.0058V11.642L3.43837 8.13413L0 6.1875V21.8239C0 23.0311 0.978125 24.0058 2.18187 24.0058H7.27275Z"
                      fill="#4285F4"
                    />
                    <path
                      d="M24.7266 24.0056H29.8174C31.0248 24.0056 31.9993 23.0274 31.9993 21.8237V6.1875L28.1048 8.41713L24.7266 11.6419V24.0056Z"
                      fill="#34A853"
                    />
                    <path
                      d="M7.2737 11.642L6.75195 6.81112L7.2737 2.1875L16.001 8.733L24.7282 2.1875L25.3118 6.5615L24.7282 11.642L16.001 18.1875L7.2737 11.642Z"
                      fill="#EA4335"
                    />
                    <path
                      d="M24.7266 2.18796V11.6425L31.9993 6.18796V3.27884C31.9993 0.580712 28.9193 -0.957414 26.7631 0.660711L24.7266 2.18796Z"
                      fill="#FBBC04"
                    />
                    <path
                      d="M0 6.18802L3.34488 8.69677L7.27275 11.6425V2.18802L5.23625 0.660769C3.07625 -0.957481 0 0.580769 0 3.27877V6.18802Z"
                      fill="#C5221F"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_7509_13680">
                      <rect width="32" height="24.125" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </i>
              Mail
            </a>
          </li>
        </ul>
      </div>
    </React.Fragment>
  );
};

export default SocialLinks;
